/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _constant = _interopDefault(require('lodash/fp/constant'));
var __ol = _interopDefault(require('openlayers'));
var core = require('../core');

var MultiPoint = __ol.geom.MultiPoint;
var props = {};

var computed = {
  type: _constant(core.GEOMETRY_TYPE.MULTI_POINT)
};

var methods = {
  /**
   * @returns {ol.geom.MultiPoint}
   * @protected
   */
  createGeometry: function createGeometry() {
    return new MultiPoint(this.fromLonLat(this.coordinates));
  }
};

var Geom = {
  name: 'vl-geom-multi-point',
  mixins: [core.geometry],
  props: props,
  computed: computed,
  methods: methods
};

var index = {
  Geom: Geom,
  install: function install(Vue) {
    Vue.component(Geom.name, Geom);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/multi-point-geom/index.js
// module id = 1188
// module chunks = 1